export const COLLABORATION_SIDEBAR_FAS_NAMESPACE = 'collaborationSidebar';
export const COMMENTING_FAS_NAMESPACE = 'commenting';